import { render } from "./Icons.vue?vue&type=template&id=1cfb772f&scoped=true"
import script from "./Icons.vue?vue&type=script&lang=js"
export * from "./Icons.vue?vue&type=script&lang=js"

import "./Icons.vue?vue&type=style&index=0&id=1cfb772f&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cfb772f"]])

export default __exports__